import { createContext } from 'react';

const RedirectContext = createContext(redirect => {});

export default RedirectContext;
